import * as moment from 'moment';

export const EN_DURATIONS_ABBR_LOCALE = 'en-durations-abbr';

// Optional: define other locale names here...

// Remember the original locale
const oldLocale = moment.locale();

// Momentjs locale for abbreviated durations (e.g. '2d' instead of '2 days'). Used on portcallprofile.js.
// Example usage: moment(lastline).locale('en-durations-abbr').from(tzutils.now())
moment.locale(EN_DURATIONS_ABBR_LOCALE, {
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: 'a few seconds',
        m: '1min',
        mm: '%dmin',
        h: '1hr',
        hh: '%dhr',
        d: '1d',
        dd: '%dd',
        M: '1mo',
        MM: '%dmo',
        y: '1yr',
        yy: '%dyr'
    }
});

// Optional: define other locales here.

// Finally, switch back to the original locale to reduce changes to global state.
moment.locale(oldLocale);


// WEBPACK FOOTER //
// ./lib/moment-custom-locales.ts